const STALE_MODULE_RELOAD_KEY = "harness-stale-module-reload";
const STALE_MODULE_RELOAD_WINDOW_MS = 30_000;

export const STALE_ENTRY_RECOVERY_SCRIPT = `(() => {
  const key = "harness-stale-entry-reload";
  const windowMs = 30_000;
  const isModuleFailure = (value) => /(?:dynamically imported module|importing a module script|failed to fetch.*module|module script failed)/i.test(String(value || ""));
  const recover = () => {
    try {
      const previous = Number(sessionStorage.getItem(key) || 0);
      if (Date.now() - previous < windowMs) return;
      sessionStorage.setItem(key, String(Date.now()));
    } catch {
      return;
    }
    const separator = location.search ? "&" : "?";
    location.replace(location.pathname + location.search + separator + "_harness_reload=" + Date.now() + location.hash);
  };
  window.addEventListener("error", (event) => {
    if (event.target instanceof HTMLScriptElement && event.target.type === "module") recover();
    else if (isModuleFailure(event.message)) recover();
  }, true);
  window.addEventListener("unhandledrejection", (event) => {
    if (isModuleFailure(event.reason instanceof Error ? event.reason.message : event.reason)) recover();
  });
  window.setTimeout(() => {
    try { sessionStorage.removeItem(key); } catch {}
  }, windowMs);
})();`;

export function isStaleModuleLoadError(message: string) {
  return /(?:dynamically imported module|importing a module script|failed to fetch.*module|module script failed)/i.test(
    message,
  );
}

function reloadForStaleModule() {
  try {
    const previousReload = Number(sessionStorage.getItem(STALE_MODULE_RELOAD_KEY) || 0);
    if (Date.now() - previousReload < STALE_MODULE_RELOAD_WINDOW_MS) return;
    sessionStorage.setItem(STALE_MODULE_RELOAD_KEY, String(Date.now()));
  } catch {
    return;
  }

  window.location.reload();
}

export function recoverFromStaleModuleLoad() {
  if (typeof window === "undefined") return;

  window.addEventListener(
    "error",
    (event) => {
      const target = event.target;
      if (target instanceof HTMLScriptElement && target.src.includes("/assets/")) {
        reloadForStaleModule();
      } else if (isStaleModuleLoadError(event.error?.message || event.message)) {
        reloadForStaleModule();
      }
    },
    true,
  );
  window.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason;
    if (
      isStaleModuleLoadError(
        reason instanceof Error ? reason.message : typeof reason === "string" ? reason : "",
      )
    ) {
      reloadForStaleModule();
    }
  });
}

export function clearLegacyServiceWorker() {
  if (!("serviceWorker" in navigator)) return;

  // Harness does not need offline document caching. Remove workers created by
  // older releases so they cannot serve stale SPA routes or asset manifests.
  void navigator.serviceWorker
    .getRegistrations()
    .then(async (registrations) => {
      await Promise.all(registrations.map((registration) => registration.unregister()));
      if (!("caches" in window)) return;

      const keys = await caches.keys();
      await Promise.all(
        keys.filter((key) => key.startsWith("harness-app-")).map((key) => caches.delete(key)),
      );
    })
    .catch((error) => {
      console.warn("Harness could not clear an older service worker.", error);
    });
}
